import React, { useState, useEffect, useCallback } from "react";

import { makeStyles, Grid, TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Album from "./Album";

import ReactPaginate from "react-paginate";

import api from "../service/api";

export default function Albuns() {
  const classes = useStyles();
  const [albums, setAlbums] = useState();
  const [albumsLastPage, setAlbumsLastPage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(0);
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  const updateData = useCallback((response) => {
    if (response && response.data && Array.isArray(response.data.data.data)) {
      setAlbums(response.data.data.data);
      const totalPages = response.data.data.pagination?.totalPages || 1;
      setAlbumsLastPage(totalPages);
    } else {
      setAlbums([]);
      setAlbumsLastPage(1);
    }
  }, []);

  const getAlbums = useCallback(
    async (page) => {
      setLoading(true);

      const offset = page ? (page - 1) * 20 : 0;
      const searchParam = debouncedSearch ? `&q=${encodeURIComponent(debouncedSearch)}` : "";
      const url = `/albums?limit=20&offset=${offset}${searchParam}`;

      api
        .get(url)
        .then((response) => updateData(response))
        .catch(e => console.log(e.message))
        .finally(() => setLoading(false));

      setCurrentPage(page ? page - 1 : 0);
    },
    [updateData, debouncedSearch]
  );

  useEffect(() => {
    getAlbums(1);
  }, [debouncedSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={classes.root}>
      <TextField
        className={classes.searchInput}
        variant="outlined"
        placeholder="Buscar álbum..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      {!loading ? (
        <>
          <>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={4}
            >
              {albums?.map((album) => (
                <Grid key={album.id} item xs={12} sm={6} md={4} lg={3}>
                  <div className={classes.item}>
                    <Album album={album} />
                  </div>
                </Grid>
              ))}
            </Grid>
          </>
          <>
            <ReactPaginate
              pageCount={albumsLastPage}
              previousLabel=""
              nextLabel=""
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              onPageChange={({ selected }) => {
                setCurrentPage(selected);
                getAlbums(selected + 1);
              }}
              containerClassName="container"
              pageClassName={classes.page}
              activeClassName="active"
              pageLinkClassName="pageLink"
              forcePage={currentPage}
            />
          </>
        </>
      ) : (
        <div>
          <span>Carregando...</span>
        </div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "48px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "100%",
    marginBottom: "64px",
  },
  searchInput: {
    width: "100%",
    maxWidth: "480px",
    marginBottom: "32px",
  },
  item: {
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  page: {
    cursor: "pointer",
    fontFamily: "Karla",
    width: "30px",
    height: "30px",
    borderRadius: "20px",
  },
}));
